<ion-row>
  <ion-col size="12" class="ion-text-center component-padding-sm">
    <img *ngIf="!isDarkMode" src="/assets/imgs/scholarships/graphic-scholarship.svg" alt="Nucamp Coding Bootcamp Scholarships" />
    <img *ngIf="isDarkMode" src="/assets/imgs/scholarships/graphic-scholarship-darkmode.svg" alt="Nucamp Coding Bootcamp Scholarships" />
    <h3 class="dark">Scholarships available for everyone needing economic support.</h3>
    <h4 class="stripe-subtitle">Get <b class="highlightPurple">up to 25% off</b> towards a Nucamp coding bootcamp from one of our scholarships.</h4>
  </ion-col>
</ion-row>

<ng-container *ngIf="!usedAs || usedAs === 'component'">
  <ion-row *ngIf="windowRef.width() > 768 && scholarships">
    <ng-container *ngTemplateOutlet="scholarshipCard"></ng-container>
  </ion-row>
  <ion-row *ngIf="windowRef.width() <= 768 && scholarships">
    <ion-col class="ion-text-center" style="margin-top: 20px;">
      <ion-button data-cy="viewscholarships" class="communitybox" (click)="openPage('/scholarships')">View available scholarships</ion-button>
    </ion-col>
  </ion-row>
</ng-container>

<ng-container *ngIf="usedAs && usedAs === 'page'">
  <ion-row *ngIf="scholarships">
    <ion-col size="12">
      <ng-container *ngTemplateOutlet="scholarshipCard"></ng-container>
    </ion-col>
  </ion-row>
</ng-container>

<!-- -------------------- -->
<!--   SCHOLARSHIP CARD   -->
<!-- -------------------- -->
<ng-template #scholarshipCard>
    <ion-slides pager="true" [options]="scholarshipSliderOptions" id="scholarshipSlider" #scholarshipSlider style="padding-bottom: 24px;">
      <ion-slide *ngFor="let scholarship of scholarships">
        <ion-row class="cards">
          <ion-col>
            <a routerDirection="root" [routerLink]="'/scholarships/' + scholarship.urlId">
              <ion-card (click)="openScholarship(scholarship.id)" class="hover">
                <img loading="lazy" src="/assets/imgs/scholarships/{{scholarship.id}}.webp"
                  alt="Nucamp {{scholarship.name}} Scholarship">
                <h4>{{scholarship.name}}</h4>
                <p class="scholarship-amount">{{scholarship.amounts.total | currency:'USD':'symbol':'1.0-0'}} Fund</p>
                <ion-card-content>
                  <div class="fund-wrap">
                    <div class="fund-progress-wrap">
                      <div class="progress"
                        [ngStyle]="{'background': 'linear-gradient(135deg,' + scholarship.gradientColors.start + '0%,' + scholarship.gradientColors.end + '100%)', 'width': scholarship.amounts.left/scholarship.amounts.total*100 + '%'}">
                      </div>
                      <div class="progress-text">{{scholarship.amounts.left | currency:'USD':'symbol':'1.0-0'}} of
                        {{scholarship.amounts.total | currency:'USD':'symbol':'1.0-0'}}</div>
                    </div>
                  </div>
                  <p>{{scholarship.target}}</p>
                </ion-card-content>
                <ion-button data-cy="viewscholarship" class="communitybox">Learn More</ion-button>
              </ion-card>
            </a>
          </ion-col>
        </ion-row>
      </ion-slide>
    </ion-slides>
    <ion-col size="12" class="nucamp-swiper-navigation ion-no-padding">
      <ion-row class="ion-no-padding">
        <ion-col size="3.2" size-sm="5" (click)="swipePrevScholarship()" class="ion-text-right nucamp-swiper-button-prev ion-no-padding"><fa-icon [icon]="faAngleDoubleLeft"></fa-icon></ion-col>
        <ion-col size="5.6" size-sm="2"></ion-col>
        <ion-col size="3.2" size-sm="5" (click)="swipeNextScholarship()" class="ion-text-left nucamp-swiper-button-next ion-no-padding"><fa-icon [icon]="faAngleDoubleRight"></fa-icon></ion-col>
      </ion-row>
  </ion-col>
</ng-template>
<!-- -------------------- -->